import React from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "@workos-inc/authkit-react";

export default function Footer() {
    let navigate = useNavigate();
    const {user} = useAuth();

    return (

        <footer className="bg-white dark:bg-gray-900">
            <div className="mx-auto max-w-7xl overflow-hidden py-12 px-4 sm:px-6 lg:px-8">
                {/* Terms & Privacy live in the menu once logged in; only show
                    them in the footer on public (logged-out) pages. */}
                {!user &&
                    <nav className="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">
                        <div key="Terms" className="px-5 py-2">
                            <span className="cursor-pointer text-base text-gray-500 dark:text-gray-400 hover:text-gray-900 hover:underline"
                                  onClick={() => {
                                      navigate('/terms');
                                  }}
                            >
                                Terms
                            </span>
                        </div>
                        <div key="Privacy" className="px-5 py-2">
                            <span className="cursor-pointer text-base text-gray-500 dark:text-gray-400 hover:text-gray-900 hover:underline"
                                  onClick={() => {
                                      navigate('/privacy');
                                  }}
                            >
                                Privacy
                            </span>
                        </div>
                    </nav>
                }
                {!user &&
                    <p className="mt-8 text-center text-base text-gray-400 dark:text-gray-500">&copy; 2026 Push Enterprise Technologies LLC.
                        All rights
                        reserved.</p>
                }
            </div>
        </footer>
    )
}
